import {StyleSheet} from 'react-native';

import {cloudLight} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {},
  address: {
    paddingVertical: 20,
  },
  divider: {
    height: 1,
    backgroundColor: cloudLight,
  },
});
